<date-picker
    [unRestrictedMax]="!!unRestrictedMax"
    (dateChange)="apply()"
    [options]="options"
    [(date)]="date"
    [monDateFormat]="dateFormat"
    class="pull-right">
</date-picker>
